import React, {useState, useEffect, useRef} from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Button,
    Alert,
    AlertTitle,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress
} from '@mui/material';
import SelectMulti from '../../../../components/select/SelectMulti';
import MonthPickerComponent from '../../../../components/date/MonthPickerComponent';
import {toast} from 'react-toastify';
import axios from "axios";
import { FINANCIAL_PLATFORMS } from '../../../../constants/financialPlatforms';
import useApi from '../../../../hooks/useApi';
import {fetchDspCompanies} from '../../../../API/FinancialTools';

function CreateRowDialog({
                             open,
                             handleClose,
                             ssp,
                             onSuccess,
                         }) {

    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = ('0' + (currentDate.getMonth() + 1)).slice(-2);
        setMonth(`${year}-${month}`);
    }, []);

    const [month, setMonth] = useState('');
    const [platform, setPlatform] = useState('');
    const [advertiser, setAdvertiser] = useState('');
    const [groups, setGroups] = useState([{ publisher_id: '', reason: '', deduction: '', type: '' }]);
    const [file_link, setFile_link] = useState('');
    const [file, setFile] = useState(null);
    const [comment, setComment] = useState('');
    const {data: dsp = [], loading: loadingDsp} = useApi(fetchDspCompanies);

    const [endpoint, setEndpoint] = useState('/api/financialtools/deduction-control/create');
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const handleMonthChange = (selectedMonth) => {
        const periodString = `${selectedMonth.year}-${selectedMonth.month}`;
        setMonth(periodString);
    };

    const handleSetFile = (event) => {
        setFile(event.target.files[0]);
    };
    const handleSetPlatform = (event) => {
        setPlatform(event.target.value);
    };
    const handleSetAdvertiser = (event) => {
        setAdvertiser(event.target.value);
    };
    const handleGroupChange = (index, field, value) => {
        setGroups(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };
    const handleAddGroup = () => {
        setGroups(prev => [...prev, { publisher_id: '', reason: '', deduction: '', type: '' }]);
    };
    const handleSetFile_link = (event) => {
        setFile_link(event.target.value);
    };
    const handleSetComment = (event) => {
        setComment(event.target.value);
    };
    const reasons = [
        { id: 'Discrepancy', name: 'Discrepancy' },
        { id: 'IVT Adjustment', name: 'IVT Adjustment' },
    ];


    const sendToServer = () => {

        const hasValidGroups = groups.length > 0 && groups.every(g => g.publisher_id && g.reason && g.deduction && g.type);

        if (!platform ||
            !advertiser ||
            !hasValidGroups
    )
        {
            toast.error('First fill required fields!');
            return;
        }

        const userId = localStorage.getItem('user_id');

        const formData = new FormData();
        if(file){
        formData.append('file', file);
        }

        if(userId){
        formData.append('user_id', userId);
        }

        if(platform){
        formData.append('platform', platform);
        }

        if(advertiser){
        formData.append('advertiser', advertiser);
        }

        if(groups && groups.length){
        formData.append('entries', JSON.stringify(groups));
        }

        if(file_link){
        formData.append('file_link', file_link);
        }

        if(month){
        formData.append('month', month);
        }

        // removed legacy single-value fields: cost, final_cost, revenue

        if(comment){
        formData.append('comment', comment);
        }


        axios.post(`${BASE_URL}${endpoint}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then((response) => {
                if (response.data.success) {
                    toast.success(response.data.message);
                    setFile(null);
                    setMonth('');
                    setPlatform('');
                    setAdvertiser('');
                    setGroups([{ publisher_id: '', reason: '', deduction: '', type: '' }]);
                    setFile_link('');
                    setComment('');
                    onSuccess();
                    handleClose();
                } else {
                    toast.error('Error: ' + response.data.message);
                }
            })
            .catch((error) => {
                toast.error('An error occurred while sending a file:', error.message);
                console.error('An error occurred while sending a file:', error.message);
            });
    };



    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Create a new row</DialogTitle>
            <DialogContent>
                <Alert variant="outlined" severity="info" color="info" sx={{marginBottom: "20px"}}>
                    Please complete this form to create a new row.<br/>
                </Alert>

                <div
                    style={{
                        userSelect: 'none',
                        borderRadius: '5px',
                        textAlign: "center",
                        backgroundColor: '#f0f3f5',
                        padding: '2px',
                        cursor: 'pointer',
                        border: '1px solid #dddfe1',
                    }}
                >
                    <div>
                        <InputLabel id="publisher-label">Choose a period</InputLabel>
                    </div>
                    <div>
                        <MonthPickerComponent onMonthChange={handleMonthChange}/>
                    </div>
                </div>

                <FormControl fullWidth margin="dense">
                    <InputLabel id="platform-label">Platform</InputLabel>
                    <Select
                        labelId="platform-label"
                        id="platform"
                        name="platform"
                        value={platform}
                        onChange={handleSetPlatform}
                        required = {true}
                        label="Platform"
                    >
                        {FINANCIAL_PLATFORMS.map((p) => (
                            <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth margin="dense">
                    <InputLabel id="advertiser-label">Advertiser</InputLabel>
                    <Select
                        labelId="advertiser-label"
                        id="advertiser_id"
                        name="advertiser_id"
                        value={advertiser}
                        onChange={handleSetAdvertiser}
                        required = {true}
                        label="Advertiser"
                    >
                        {dsp.map((d) => (
                            <MenuItem key={d.value.id} value={d.value.id}>
                                {d.value.name} (ID: {d.value.id})
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {groups.map((group, index) => (
                    <div key={index} style={{ marginTop: '24px', marginBottom: '24px' }}>
                        <div style={{ fontWeight: 600, marginBottom: '8px' }}>Publisher {index + 1}</div>
                        <FormControl fullWidth margin="dense">
                            <InputLabel id={`publisher-label-${index}`}>Publisher</InputLabel>
                            <Select
                                labelId={`publisher-label-${index}`}
                                id={`publisher_id_${index}`}
                                name={`publisher_id_${index}`}
                                value={group.publisher_id}
                                onChange={(e) => handleGroupChange(index, 'publisher_id', e.target.value)}
                                required = {true}
                                label="Publisher"
                            >
                                {ssp.map((ssp) => (
                                    <MenuItem key={ssp.value.id} value={ssp.value.id}>
                                        {ssp.value.name} (ID: {ssp.value.id})
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl fullWidth margin="dense">
                            <InputLabel id={`reason-label-${index}`}>Reason</InputLabel>
                            <Select
                                labelId={`reason-label-${index}`}
                                id={`reason_${index}`}
                                name={`reason_${index}`}
                                value={group.reason}
                                onChange={(e) => handleGroupChange(index, 'reason', e.target.value)}
                                required = {true}
                                label="Reason"
                            >
                                {reasons.map(r => (
                                    <MenuItem key={r.id} value={r.id}>{r.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <TextField
                            margin="dense"
                            id={`deduction_${index}`}
                            label="Deduction"
                            type="number"
                            fullWidth
                            name={`deduction_${index}`}
                            value={group.deduction}
                            onChange={(e) => handleGroupChange(index, 'deduction', e.target.value)}
                            required = {true}
                        />

                        <FormControl fullWidth margin="dense">
                            <InputLabel id={`type-label-${index}`}>Type</InputLabel>
                            <Select
                                labelId={`type-label-${index}`}
                                id={`type_${index}`}
                                name={`type_${index}`}
                                value={group.type}
                                onChange={(e) => handleGroupChange(index, 'type', e.target.value)}
                                required = {true}
                                label="Type"
                            >
                                <MenuItem value={'Cost'}>Cost</MenuItem>
                                <MenuItem value={'Revenue'}>Revenue</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                ))}

                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '8px', marginBottom: '8px' }}>
                    <Button variant="outlined" onClick={handleAddGroup}>+ Add Publisher</Button>
                </div>

                <TextField
                    margin="dense"
                    id="file_link"
                    label="File Link"
                    type="text"
                    fullWidth
                    name="file_link"
                    value={file_link}
                    onChange={handleSetFile_link}
                />

                <div>
                    <InputLabel id="publisher-label">Or choose a file</InputLabel>
                </div>
                <div>
                    <input
                        type="file"
                        id="file"
                        name="file"
                        onChange={handleSetFile}
                    />
                </div>

                <TextField
                    margin="dense"
                    id="comment"
                    label="Revision Comment"
                    type="text"
                    fullWidth
                    name="comment"
                    value={comment}
                    onChange={handleSetComment}
                    multiline
                    rows={3}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={sendToServer} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default CreateRowDialog;